import del from './delete';
export default { del };
